import { Module } from '../Module';
import { _handle } from './functions/_handle';

/**
 * Module for Transitions.
 *
 * This module handles the page-transitions
 */
export class PageTransition extends Module {
	initialize() {
		_handle();
	}
}
